module.exports = __webpack_public_path__ + "static/media/standing.f940d3d2.jpg";